import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Submission } from "../types/submissions";
import { BASE_URL, envConfig } from "../config";

// Define a service using a base URL and expected endpoints
export const submissionsApi = createApi({
  reducerPath: "submissionsApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "submissions",
    prepareHeaders: (headers) => {
        headers.set("api-key", `${envConfig.API_KEY}`);

      return headers;
    },
  }),
  tagTypes: ["Submissions", "Students"],
  endpoints: (builder) => ({
    getSubmissions: builder.query<Submission[], string>({
      query: () => `/`,
      providesTags: ["Submissions"],
    }),
    getRecentSubmissions: builder.query<Submission[], string>({
      query: () => `/recent`,
      providesTags: ["Submissions"],
    }),
    updateSubmission: builder.mutation<Submission, Submission>({
      query: ({ _id, ...patch }) => ({
        url: `/${_id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: ["Submissions"],
    }),
    transferSubmission: builder.mutation<Submission, string>({
      query: (_id) => ({
        url: `transfer/${_id}`,
        method: "POST",
      }),
      invalidatesTags: ["Submissions", "Students"],
    }),
    deleteSubmission: builder.mutation<
      { success: boolean; _id: string },
      string
    >({
      query: (_id) => ({
        url: `/${_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Submissions"],
    }),
    createSubmission: builder.mutation<Submission, Submission>({
      query: ({ _id, ...submission }) => ({
        url: `/`,
        method: "POST",
        body: submission,
      }),
      invalidatesTags: ["Submissions"],
    }),
    createSubmissionBatch: builder.mutation<Submission[], Submission[]>({
      query: (submissions) => ({
        url: `/batch`,
        method: "POST",
        body: submissions,
      }),
      invalidatesTags: ["Submissions"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSubmissionsQuery,
  useGetRecentSubmissionsQuery,
  useUpdateSubmissionMutation,
  useCreateSubmissionMutation,
  useDeleteSubmissionMutation,
  useTransferSubmissionMutation,
  useCreateSubmissionBatchMutation,
} = submissionsApi;
